import { Component, OnInit, EventEmitter, Output, Input, AfterViewInit } from "@angular/core";
import { GridService } from "Services/grid.service";
import { GridConfig } from "Classes/GridConfig";
declare var $: any;

@Component({
    selector: "grid",
    template: require('./grid.component.html'),
    styles: [require('./grid.component.css')]
})

export class GridComponent implements OnInit {
    constructor(
        private gridService: GridService
    ) { }

    @Input() gridConfig: GridConfig;
    @Output() gridLoaded: EventEmitter<any> = new EventEmitter<any>();
    id: string;
    grid: any;

    ngOnInit() {
        this.id = this.gridConfig.id;
    }

    ngAfterViewInit() {
        this.grid = this.gridService.loadGrid(this.gridConfig);
        this.gridLoaded.emit(this.grid);
        if(this.gridConfig.data.length == 0)
            this.grid.find(".jqgfirstrow").css("height", "1px");
        this.formatGrid();

    }

    formatGrid() {
        $("#gbox_" + this.id + " tr.ui-jqgrid-labels").sortable({
            distance: 20
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Components/grid.component.ts